import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const CreateProgramMutation = graphql(`
    mutation CreateProgram($input: CreateProgramInput!) {
        createProgram(input: $input) {
            __typename
            ... on CreateProgramSuccessfulResponse {
                result {
                    ...ProgramItemData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const ProgramItemData = graphql(`
    fragment ProgramItemData on Program {
        id
        name
        description
        companyId
    }
`);

export type CreateProgramMutationVariables = VariablesOf<typeof CreateProgramMutation>;
